import { FC } from 'react'
import { Container, Paper, Typography, Divider, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

const PrivacidadePage: FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper sx={{ p: { xs: 3, md: 5 } }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Política de Privacidade
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Última atualização: 28/04/2026
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body1" paragraph>
          A Originei (&quot;nós&quot;, &quot;nossa plataforma&quot;) tem o compromisso de
          tratar com transparência e segurança os dados pessoais coletados na operação da nossa
          plataforma B2B de crédito e intermediação financeira. Esta política descreve quais dados
          tratamos, com qual finalidade, por quanto tempo e quais são os seus direitos como titular,
          em conformidade com a Lei Geral de Proteção de Dados (Lei 13.709/2018).
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          1. Dados que coletamos
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Identificação da empresa cliente</strong>: razão social, CNPJ, atividade econômica,
          faturamento, dados financeiros e endereço.<br />
          • <strong>Contatos da empresa cliente</strong> (pessoa física): nome, e-mail, telefone, cargo.<br />
          • <strong>Usuários do portal</strong> (consultores, gerentes, administradores): nome, e-mail
          corporativo, papéis, atributos do canal.<br />
          • <strong>Dados das operações</strong>: valores, NFs, sacados, indicadores financeiros e
          documentos anexados.<br />
          • <strong>Dados de uso</strong>: registros de acesso, IP, User-Agent e ações executadas (auditoria).
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          2. Finalidade do tratamento
        </Typography>
        <Typography variant="body1" paragraph>
          Os dados são tratados exclusivamente para: estruturação e análise de operações de crédito,
          comunicação contratual com a empresa cliente, geração da Defesa de Crédito, atendimento a
          obrigações regulatórias e exercício regular de direito.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          3. Base legal
        </Typography>
        <Typography variant="body1" paragraph>
          Tratamos os dados com base em (Art. 7º LGPD): <strong>execução de contrato</strong> com a
          empresa cliente; <strong>cumprimento de obrigação legal</strong> e regulatória do mercado
          financeiro; <strong>legítimo interesse</strong> para auditoria e prevenção a fraudes; e
          <strong>consentimento</strong> quando expressamente solicitado.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          4. Compartilhamento
        </Typography>
        <Typography variant="body1" paragraph>
          Compartilhamos dados com instituições financeiras parceiras estritamente para a estruturação
          das operações solicitadas. Não comercializamos dados pessoais. Operadores tecnológicos (cloud,
          e-mail transacional) atuam sob acordos de confidencialidade.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          5. Tempo de retenção
        </Typography>
        <Typography variant="body1" paragraph>
          • Dados de operações ativas: enquanto durar a relação contratual.<br />
          • Dados após encerramento: até 5 anos para cumprimento de obrigação fiscal e regulatória.<br />
          • Logs de auditoria: 5 anos a partir do registro.<br />
          • Contatos de empresas inativas: até 2 anos.<br />
          Após esses prazos, os dados são <strong>anonimizados ou eliminados</strong>.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          6. Seus direitos como titular (Art. 18 LGPD)
        </Typography>
        <Typography variant="body1" paragraph>
          Você pode, a qualquer momento, solicitar: confirmação da existência de tratamento; acesso aos
          seus dados; correção de dados incompletos ou desatualizados; anonimização, bloqueio ou
          eliminação; portabilidade; informações sobre compartilhamento; revogação de consentimento.
          Para exercer qualquer direito, entre em contato com nosso{' '}
          <Link component={RouterLink} to="/dpo">Encarregado pelo Tratamento (DPO)</Link>.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          7. Segurança
        </Typography>
        <Typography variant="body1" paragraph>
          Adotamos medidas técnicas e organizacionais: autenticação OAuth2/OIDC, criptografia em
          trânsito (TLS), controle de acesso por papel, mascaramento de dados pessoais em logs e
          trilha de auditoria com identificação de quem acessou, quando e de qual IP.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          8. Cookies
        </Typography>
        <Typography variant="body1" paragraph>
          Utilizamos apenas cookies estritamente necessários ao funcionamento do portal (autenticação
          e sessão). Não utilizamos cookies de rastreio publicitário.
        </Typography>

        <Typography variant="h6" fontWeight={700} sx={{ mt: 3 }} gutterBottom>
          9. Contato
        </Typography>
        <Typography variant="body1" paragraph>
          Dúvidas sobre esta política devem ser direcionadas ao{' '}
          <Link component={RouterLink} to="/dpo">DPO da Originei</Link>.
        </Typography>

        <Divider sx={{ my: 4 }} />
        <Typography variant="caption" color="text.secondary">
          Documento sujeito a atualizações. Você será notificado em caso de alterações materiais.
        </Typography>
      </Paper>
    </Container>
  )
}

export default PrivacidadePage
